import { nextFrame } from "../../../animation/nextFrame";
import { sleep } from "../../../animation/sleep";
import { BinaryFunction } from "../../../math/BinaryFunction";
import { AudioBufferChannelReader, ExtremesReader, LeftReader, MaxAbsoluteReader, MiddleReader, RightReader } from "../../AudioBufferChannelReader";
import { WaveformShape } from "../waveform-old/WaveformShape";
import { WaveForm } from "./WaveForm";
import { WaveFormBlockReader } from "./WaveFormBlockReader";
import { WaveformChannelType, WaveformGenerationOptions } from "./WaveFormGenerationOptions";
import { WaveLevels } from "./WaveLevels";

export class WaveFormGenerator
{
  _waveForm1:WaveForm;
  _waveForm2:WaveForm;
  
  _reader:WaveFormBlockReader;

  static generate( audioBuffer:AudioBuffer, options:WaveformGenerationOptions ):Promise<WaveForm[]>
  {
    let generator = new WaveFormGenerator();

    generator._reader = new WaveFormBlockReader( options.lowestZoomLevel + 1 );

    let highestZoomLevel = options.highestZoomLevel;
    let lowestZoomLevel  = options.lowestZoomLevel;
    let numSamples       = audioBuffer.getChannelData( 0 ).length;

    let minLevelsR = new WaveLevels( highestZoomLevel, lowestZoomLevel, numSamples );
    let maxLevelsR = new WaveLevels( highestZoomLevel, lowestZoomLevel, numSamples );

    let minLevelsL = new WaveLevels( highestZoomLevel, lowestZoomLevel, numSamples );
    let maxLevelsL = new WaveLevels( highestZoomLevel, lowestZoomLevel, numSamples );

    let leftReader     = new LeftReader();
    let rightReader    = new RightReader();
    let middleReader   = new MiddleReader();
    let extremesReader = new ExtremesReader();
    let maxReader      = new MaxAbsoluteReader();

    let reader1 = leftReader;
    let reader2 = rightReader;

    let hasTwoChannels = false;

    switch (  options.type )
    {
      case WaveformChannelType.LR_SEPERATE:
      {
        hasTwoChannels = true;
      }
      break;

      case WaveformChannelType.RIGHT:
      {
        reader1 = rightReader;
      }
      break;

      case WaveformChannelType.MIDDLE:
      {
        reader1 = middleReader;
      }
      break;

      case WaveformChannelType.MAX_ABSOLUTE:
      {
        reader1 = maxReader;
      }
      break;

      case WaveformChannelType.EXTREMES:
      {
        reader1 = extremesReader;
      }
      break;
    }

    generator._waveForm1  = new WaveForm( audioBuffer, minLevelsL, maxLevelsL, reader1 ); 
    generator._waveForm2  = new WaveForm( audioBuffer, minLevelsR, maxLevelsR, reader2 );     

    let sampleOffset = 0;

    
    
    let promise = new Promise<WaveForm[]>(
      async ( resolve, reject )=>
      {
        let holdTime = new Date().getTime() + 1000 / 60;

        while ( sampleOffset < numSamples )
        {
          if ( hasTwoChannels )
          {
            this._readChannel( audioBuffer, sampleOffset, generator._reader, generator._waveForm1 );
            this._readChannel( audioBuffer, sampleOffset, generator._reader, generator._waveForm2 );
          }
          else 
          {
            this._readChannel( audioBuffer, sampleOffset, generator._reader, generator._waveForm1 );
          }  

          sampleOffset += generator._reader.numSamples;

          let now = new Date().getTime();

          if ( now > holdTime )
          {
            holdTime = now + 1000 / 60;
            await nextFrame();            
          }
        }

        if ( WaveformChannelType.LR_SEPERATE === options.type )
        {
          resolve( [ generator._waveForm1, generator._waveForm2 ] );          
        }
        else
        {
          resolve( [ generator._waveForm1 ] );
        }
      }
    );

    return promise;
  }

  static _readChannel( audioBuffer:AudioBuffer, sampleOffset:number, blockReader:WaveFormBlockReader, waveform:WaveForm )
  {
    blockReader.readData( waveform.reader, audioBuffer, sampleOffset );

    blockReader.compressAndCopyTo( WaveLevels.max, waveform.max, sampleOffset );
    blockReader.compressAndCopyTo( WaveLevels.min, waveform.min, sampleOffset );

  }
}